<template>
	<v-dialog
		:model-value="modelValue"
		max-width="560px"
		transition="fade-transition"
		@update:model-value="$emit('update:modelValue', $event)"
	>
		<v-card>
			<v-toolbar color="primary" dark flat>
				<v-toolbar-title>
					{{ readOnly ? "Choose extraction to view" : "Choose extraction" }}
				</v-toolbar-title>
				<v-hover-icon class="mr-3" />
			</v-toolbar>

			<v-card-text class="pb-0 pt-4">
				<p class="text-body-2">
					You have {{ entries.length }} open extractions on
					<strong>{{ paperName || "this paper" }}</strong
					>. Choose the one to {{ readOnly ? "view" : "continue" }}:
				</p>
			</v-card-text>

			<v-list class="py-0" lines="two">
				<v-list-item
					v-for="entry in entries"
					:key="entry.uuid"
					class="px-6"
					@click="$emit('select', entry)"
				>
					<v-list-item-title class="text-body-2">
						{{ entryLabel(entry) }}
					</v-list-item-title>

					<v-list-item-subtitle class="text-caption">
						Last saved {{ formatDateTime(entry.updated_at) }}
					</v-list-item-subtitle>

					<template #append>
						<v-chip
							size="x-small"
							variant="flat"
							class="bg-surface-tint text-fg-1 flex-shrink-0 ml-3"
						>
							{{ formatLabel(entry) }}
						</v-chip>
					</template>
				</v-list-item>
			</v-list>

			<v-card-actions class="px-6 py-4">
				<v-spacer />

				<v-btn
					class="bg-grey"
					elevation="2"
					@click="$emit('update:modelValue', false)"
				>
					Cancel
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import VHoverIcon from "@/components/VHoverIcon";

export default {
	name: "ExtractionSelectDialog",

	components: {
		VHoverIcon,
	},

	props: {
		modelValue: Boolean,
		// Open data entries to choose from, as served in paper.dataEntries:
		// snake_case columns (created_at, updated_at, reopened_at, data_format)
		// with camelCase relation keys (createdUser), matching how the API
		// serializes dataEntries itself.
		entries: {
			type: Array,
			default: () => [],
		},
		paperName: {
			type: String,
			default: "",
		},
		// Read-only flow ("View Paper") vs starting/continuing an extraction.
		readOnly: Boolean,
		// Used to label the current user's own entries as "you".
		currentUserUuid: {
			type: String,
			default: "",
		},
	},

	emits: ["update:modelValue", "select"],

	methods: {
		entryLabel(entry) {
			if (entry.reopened_at) {
				return `Reopened ${this.formatDate(entry.reopened_at)}, originally by ${this.creatorLabel(entry)}`;
			}

			return `Started by ${this.creatorLabel(entry)} on ${this.formatDate(entry.created_at)}`;
		},
		creatorLabel(entry) {
			const creator = entry.createdUser;

			if (!creator) {
				return "unknown";
			}

			if (creator.uuid === this.currentUserUuid) {
				return "you";
			}

			const name =
				`${creator.first_name || ""} ${creator.last_name || ""}`.trim();

			return name || creator.email || "unknown";
		},
		formatLabel(entry) {
			return entry.data_format === "DACTYL_SDE" ? "SDEv2" : "SDEv1";
		},
		formatDate(value) {
			return value ? new Date(value).toLocaleDateString() : "unknown date";
		},
		// Full timestamp: two entries can be saved the same day, and the time
		// is what tells them apart.
		formatDateTime(value) {
			return value ? new Date(value).toLocaleString() : "unknown";
		},
	},
};
</script>
